import React, { Component } from "react";
import { requestOtp, loginOtp } from "../../services/rest";
import Validator from "../../utils/Validator";
import VodCookieGenerator from "../../utils/vod-cookie-generator";
import { toast } from "react-toastify";
import {
  OTP_VALIDATION_ERROR,
  RETRY_CAPTCHA_MESSAGE
} from "../../utils/constants";
import ErrorHandler from "../../utils/error-handler";
import ToolTip from "./ToolTip";
import "react-toastify/dist/ReactToastify.css";
import TaggingHelper from "../../tagging/tagging-helper";
import OtpInput from "../common/OtpInput";

toast.configure();
class OtpForm extends Component {
  defaultState = {
    token: null,
    otp: "",
    showRecaptcha: false,
    inValidOtp: true,
    otpActive: false,
    message: "",
    previousPropData: null
  };
  constructor(props) {
    super(props);
    if (props.data && props.data.previousState) {
      this.state = {
        ...props.data.previousState
      };
    } else {
      this.state = {
        ...this.defaultState,
        // token: props.data.currentState.token,
        previousPropData: props.data.currentState,
        message: props.data.message,
        showRecaptcha: false
      };
    }
  }

  componentDidMount() {
    if (this.props.data && this.props.data.text === "GET NEW OTP") {
      this.resendVerificationLink();
    }
  }

  componentWillUnmount() {
    TaggingHelper.resetLoginOTPCache();
  }

  disableField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: false
    });
  };

  activateField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: true
    });
    if (e.target.name === "otp") {
      TaggingHelper.loginOTPFormEditEvent();
    }
  };

  _onOtpChange = (otpValue) => {
    this.setState({
      inValidOtp: this.isInValidOTP(otpValue),
      otp: otpValue
    });
    if (otpValue.length === 1) {

      TaggingHelper.loginOTPFormEditEvent();
    }
  };

  _onVerifyCallback = (token) => {
    this.setState({ token, showRecaptcha: false });
    this.resendVerificationLink();
  };
  isInValidOTP = (otp) => {

    return otp.length !== 6 || !Validator.isValidOtp(otp);
  };

  _onExpiredCallback = () => {
    this.setState({ token: null, showRecaptcha: true });
  };

  displayCaptcha = () => {
    this.setState({ token: null, showRecaptcha: true });
  };

  notify = (message) => {
    toast.dismiss();
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT
    });
  };

  _onOtpLogin = (e) => {
    e.preventDefault();
    this.props.showUILoader(true);
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    const vodWebRedirect = urlParams.get('vod-web-redirect');

    const { redirectUrl } = this.props;
    let finalRedirectUrl;

    if (redirectUrl) {
      finalRedirectUrl = redirectUrl;
    } else if (vodWebRedirect) {
      finalRedirectUrl = atob(vodWebRedirect);
    }

    loginOtp(
      this.state.previousPropData.username,
      this.state.otp,
      finalRedirectUrl
    )
      .then((response) => {
        if (response && response.data && response.data.result) {
          TaggingHelper.loginOTPSuccessEvent();
          const targetUrl =
            process.env.REACT_APP_BASE_URL + response.data.result.redirect;
          if (this.props.redirectUrl) {
            VodCookieGenerator.setVodaCookie("login-ui-redirection", targetUrl);
          }
          window.location.href = targetUrl;
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        ErrorHandler.handleOtpLoginApiError(
          error,
          this.props.goto,
          this.state,
          "ENTER_OTP",
          this.state.previousPropData
        );
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.loginApiErrorEvent(errorMessage);
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };

  resendVerificationLink = () => {
    this.props.showUILoader(true);
    requestOtp(this.state.previousPropData.username, this.state.previousPropData.password, this.state.token)
      .then((response) => {
        if (response.data && response.data.result && response.status === 201) {
          const message = response.data.result.message || "";
          this.notify(message);
          TaggingHelper.loginOTPResentEvent();
        } else {
          throw new Error("UNEXPECTED_ERROR");
        }
      })
      .catch((error) => {
        const furtherActionFlag = ErrorHandler.handleResendOtpError(
          error,
          this.notify,
          this.displayCaptcha
        );
        if (furtherActionFlag) {
          ErrorHandler.handleLoginOtpRequestError(
            error,
            this.props.goto,
            this.state.previousPropData,
            "LOGIN"
          );
        }
        const errorMessage = ErrorHandler.getErrorMessage(error).errorMessage;
        TaggingHelper.loginApiErrorEvent(errorMessage);
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };
  onGoBack = () => {
    this.props.goto("LOGIN", {
      previousState: {
        ...this.state.previousPropData,
        isUsernameValid: true,
        isPasswordValid: true
      }
    });
  };

  formatMessageWithBoldMsisdn = (message) => {

    const msisdnPattern = /(\d{2,3}\*+\d{2,3})/;
    const match = message.match(msisdnPattern);
    
    if (match) {

      const parts = message.split(match[0]);
      return (
        <>
          {parts[0]}<strong>{match[0]}</strong>{parts[1]}
        </>
      );
    }
    return message;
  };

  render() {
    const { showRecaptcha,otp, inValidOtp, message } = this.state;
    return (
      <React.Fragment>
        <div className="card-header">
          <h2>Enter your OTP</h2>
          <p>{this.formatMessageWithBoldMsisdn(message)}</p>
        </div>
        <div className="field-group otp-field-group">
          <OtpInput
            length={6}
            onChange={this._onOtpChange}
            hasError={otp.length === 6 && inValidOtp}
            isMasked={true}
            maskDelay={0}
          />
          {otp.length === 6 && inValidOtp && (
            <p className="infield-error-label">{OTP_VALIDATION_ERROR}</p>
          )}
        </div>
        <div className="action-button-wrapper">
          <button

            type="submit"
            className="btn btnRed fullwidth"
            disabled={inValidOtp}
            onClick={(e) => this._onOtpLogin(e)}
            automationid="LOGIN_FORM_OTPFORM_2"
          >
            Next
          </button>
        </div>

        <div className="action-button-wrapper">
          <button
            type="button"
            className="btn btnWhite fullwidth"
            onClick={this.onGoBack}
            automationid="LOGIN_FORM_OTPFORM_3"
          >
            Back
          </button>

        </div>
        {/* {showRecaptcha && (
          <div className="captcha-wrapper">
            <ReCaptcha
              sitekey={"6LdNAAwUAAAAALEhZyYgkqFtXUPKVhD5Fj2XaWUm"}
              verifyCallback={this._onVerifyCallback}
              expiredCallback={this._onExpiredCallback}
            />
          </div>
        )} */}
        <div className="card-footer">
          <p>
            {"Haven't received anything? "}
            <button
              type="button"
              className={`button-link ${showRecaptcha ? "button-link-disabled" : ""
                }`}
              automationid="LOGIN_FORM_OTPFORM_4"
              onClick={this.resendVerificationLink}
            >
              {`  Resend OTP `}
            </button>
            {showRecaptcha && (
              <ToolTip
                tooltip_message={RETRY_CAPTCHA_MESSAGE}
                position={`top`}
              />
            )}
          </p>
        </div>
      </React.Fragment>
    );
  }
}

export default OtpForm;
